<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left">
        <img src="../../assets/img/返回箭头.png" class="nav-img" @click="back()" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">备注</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>
    <div class="txt-block ub">
      <input type="text" v-model="note" placeholder="输入给ta的专属称呼" class="txt ub-f1"/>
    </div>

    <div class="ub ub-pc ub-ac" >
      <div class="btn" @click="seve()">完成</div>
    </div>

    <div class="ub ub-ac ub-pc" v-if="vip_level<=0">
      <label class="vip-tip">此功能为会员特权功能，
        <a @click="goto_vip()" class="go-vip">点击成为会员~</a>
      </label>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      uid_to: "",
      note: "",
      vip_level:"",
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法
    ...mapActions(["act_reload_userinfo","act_get_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_vip() {
      this.$router.push({ name: "vip_center" });
    },
    init_page() {
      //接收参数
      if (this.$route.params.uid_to) {
        this.uid_to = this.$route.params.uid_to;
      }
      if (this.$route.params.note) {
        this.note = this.$route.params.note;
      }
      var uid = this.$store.state.uid;
      var self = this;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.vip_level=u.vip_level;
        },
      });
    },
    seve() {
         //检查是否是vip,如果不是不给用
        if(this.vip_level<=0){
           this.$toast.top("此功能为会员专属！");
            return false;
        }

      var uid = this.$store.state.uid;
      var self = this;
      this.post({
        url: "/App/Note_Save",
        data: { uid: uid, uid_to: self.uid_to, note: self.note },
        success: function (serve_data) {
          if (serve_data.state == 1) {
            self.$toast.center("修改成功！");
            sessionStorage.removeItem("note" + self.uid_to);
          } else {
            self.$toast.center("修改失败！");
          }
          self.back();
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #EFEFEF;
}
.txt-block {
  .txt {
    padding-left: 0.8rem;
    padding-bottom: 0;
    height: 3rem;
    border: 0;
    outline: 0;
    font-size: 0.9rem;
    margin-top: 0.3rem;
    background: #FDFDFD;
    color: #333;
  }
  .txt::placeholder {
    color: #333;
  }
}

.btn {
  padding: 0.3rem 8rem;
  color: #fff;
  line-height: 2.4rem;
  text-align: center;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  margin: 1.5rem 0;
}

.vip-tip {
  color: #333;
  font-size: 0.75rem;
  .go-vip {
    color: rgb(186, 97, 255);
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .txt-block {
    .txt {
      background-color: #2c2b30;
      color: #fff;
    }
    .txt::placeholder {
      color: #DFDFDF;
    }
  }
  .vip-tip {
    color: #DFDFDF;
  }
}

</style>